// extracted by mini-css-extract-plugin
module.exports = {"root":"IncidentCardContainer_root__3uYJh","clickAbleBox":"IncidentCardContainer_clickAbleBox__3Fevr"};